export default __webpack_public_path__ + "static/media/邝伟信.6e9def06.png";